import { filterClusters, filterNames, filterParentName } from 'utils/filters';
import { DATA_SOURCES } from '@/config/constants';
import GoogleRelatedSectionTable from '../GoogleRelatedTable/GoogleRelatedSectionTable';
import { TableClusterNameCell } from 'components/DataVis/DataTable/styledComponents';
import { createDefaultColumns } from '../DataTable/utils';
import { useEntity } from 'utils/hooks/api';

/**
 * Related searches for the explore page, grouped by affinity group.
 *
 * The same table as the cat3/cat5/brand pages, minus the heading: the explore
 * page carries its own. The group selection is a filter the server applies
 * (``affinity_group``), as on the other three sources.
 */
function ExploreRelatedSearchesGroupTable({
    categoryId,
    brandId,
    countryId,
    controller = null,
    handleFilter = {
        cluster: filterClusters,
        parentName: filterParentName,
        name: filterNames,
    },
    ...restProps
}) {
    const relatedItem = useEntity({
        id: categoryId || brandId,
        entityType: categoryId ? 'categories' : 'brands',
        dataSource: DATA_SOURCES.GOOGLE,
    }).data;
    const relatedName = relatedItem?.name || null;

    const getColumnsConfig = (visibleOrderedMetrics) => {
        const columnsConfig = createDefaultColumns([
            'name',
            'parentName',
            ...visibleOrderedMetrics,
        ]);
        columnsConfig[0].label = relatedName ? `a-z: ${relatedName}` : 'a-z';
        columnsConfig[0].formatCell = ({ value, row }) => (
            <TableClusterNameCell
                cluster={row.cluster}
                fetching={row.fetchingData}
                relatedName={relatedName}
                name={value}
            />
        );
        const parentNameColumn = columnsConfig.find(
            (column) => column.key === 'parentName',
        );
        if (parentNameColumn) parentNameColumn.label = 'group';
        return columnsConfig;
    };

    return (
        <GoogleRelatedSectionTable
            paginateBy="affinities"
            categories={categoryId}
            brands={brandId}
            countries={countryId}
            controller={controller}
            getColumnsConfig={getColumnsConfig}
            handleFilter={handleFilter}
            rowHeight={60}
            {...restProps}
        />
    );
}

export default ExploreRelatedSearchesGroupTable;
